import Radio from 'common/domain/radio';

// @flow

export type NotificationStatus =
  | 'DEFAULT'
  | 'WARNING'
  | 'ERROR'
  | 'SUCCESS';

export type NotificationData = {
  title: string,
  message: string,
  url: string,
  radio?: Radio,
  reference: string,
  status?: NotificationStatus,
  toast?: boolean,
};

export default class Notification {
  title: string;
  message: string;
  url: string;
  radio: ?Radio;
  reference: string;
  read: boolean;
  toast: boolean;
  status: NotificationStatus;

  constructor(data: NotificationData) {
    this.title = data.title;
    this.message = data.message;
    this.url = data.url;
    this.radio = data.radio;
    this.reference = data.reference;
    this.read = false;
    this.toast = Boolean(data.toast);
    this.status = data.status || 'DEFAULT';
  }

  isSame(other: Notification) {
    return this.reference === other.reference;
  }

  hasStatus(status: NotificationStatus) {
    return this.status === status;
  }

  getType() {
    return 'DEFAULT';
  }

  getUrl(): string | void {
    return this.url;
  }

  sendToast(): Notification {
    const n = this.clone();
    n.toast = false;
    return n;
  }

  markRead(): Notification {
    const n = this.clone();
    n.toast = false;
    n.read = true;
    return n;
  }

  markUnread(): Notification {
    const n = this.clone();
    n.read = false;
    return n;
  }

  toggleRead(): Notification {
    const n = this.clone();
    n.read = !this.read;
    return n;
  }

  isRead(): boolean {
    return this.read;
  }

  clone(): Notification {
    return new Notification(this);
  }

  equals(other: Notification): boolean {
    return this.reference === other.reference;
  }
}



// WEBPACK FOOTER //
// ./src/common/modules/ui/domain/Notification.js